<template>
    <div id="header">
        <div class="content">
            <div class="w1200">
                <div class="tit">
                    <div v-if="vuex_userInfo.nickName">
                        <div class="userInfo">
                            <span @click="$router.replace('/home')">欢迎您来到缩水师网</span>
                            <div>
                                <span class="dropDown">{{ vuex_userInfo.nickName }}</span>
                                <ul>
                                    <li @click=" $router.push('/personalCenter/userinfo/yhzx?params=0,0')"> 个人中心</li>
                                    <li @click="$router.push('/personalCenter/userinfo/mess?params=0,2')">站内信</li>
                                    <li @click="$router.push('/personalCenter/userinfo/edit?params=0,1')">修改邮箱</li>
                                    <li @click="$router.push('/personalCenter/userinfo/smrz')">实名认证</li>
                                    <li @click="$router.push('/personalCenter/chongzhihetixian/suobichongzhi')">缩币充值({{
                                        vuex_userInfo.userAccount.virtualCoin || 0 }})</li>

                                    <li>
                                        <span @click="$router.push('/login')">登录</span> / <span
                                            @click="$router.push('/login/register')">注册</span>
                                    </li>

                                    <!-- <li @click="$router.push('/login/forgetPassword')"> 忘记密码 </li> -->

                                    <li @click="outLogin">安全退出</li>
                                </ul>
                            </div>
                            <div>
                                <span class="dropDown">预测/发布</span>
                                <ul>
                                    <li @click="$router.push('/personalCenter/sss_yc/ssq_sss_yc')">双色球缩水预测</li>
                                    <li @click="$router.push('/personalCenter/sss_yc/dlt_sss_yc')">大乐透缩水预测</li>
                                    <li @click="$router.push('/personalCenter/sss_yc/fcsd_sss_yc')">3d缩水预测</li>
                                    <li @click="$router.push('/personalCenter/sss_yc/pls_sss_yc')">排三缩水预测</li>

                                    <li @click="$router.push('/personalCenter/jqs_fabu/ssq_excel_fabu')">双色球条件发布</li>
                                    <li @click="$router.push('/personalCenter/jqs_fabu/dlt_excel_fabu')">大乐透条件发布</li>
                                    <li @click="$router.push('/personalCenter/jqs_fabu/fcsd_jqs_fabu')">3d条件发布</li>
                                    <li @click="$router.push('/personalCenter/jqs_fabu/pls_excel_fabu')">排三条件发布</li>
                                    <li @click="$router.push('/personalCenter/jqs_fabu/xianzhi_excel_fabu')">闲置/定制EXCEL
                                    </li>
                                    <li @click="$router.push('/personalCenter/jqs_fabu/no_room_for_error')">不容错条件试点区
                                    </li>
                                </ul>
                            </div>

                            <div class="msg">
                                <svg t="1745331974792" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                    xmlns="http://www.w3.org/2000/svg" p-id="2598" width="16" height="16">
                                    <path
                                        d="M510.5152 23.7568a488.1408 488.1408 0 1 0 0 976.2304 488.1408 488.1408 0 0 0 0-976.2304z m0 796.16a58.5728 58.5728 0 1 1 58.5728-58.624c0 32.3584-26.1632 58.624-58.5216 58.624z m58.5728-225.6384c0 24.32-26.1632 43.9296-58.5728 43.9296-32.3584 0-58.5728-19.5584-58.5728-43.9296V242.8928c0-24.2688 26.2144-43.8784 58.5728-43.8784 32.3584 0 58.5728 19.6096 58.5728 43.8784v351.3856z"
                                        fill="#d81e06" p-id="2599"></path>
                                </svg>
                                缩水网声明:本站仅可购买缩水数据、缩水条件、缩水软件、众筹招股、不能购彩!
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <!-- <span @click="$router.replace('/home')">logo</span> -->
                        <div>
                            <span>欢迎您来到缩水师网</span>
                            <span class="btn login" @click="$router.push('/login')">登录</span>
                            <span class="btn register" @click="$router.push('/login/register')">注册</span>
                        </div>
                    </div>

                    <div class="siteMap">
                        <div class="lottery-nav">
                            <div class="nav-trigger">彩票导航</div>
                            <div class="nav-panel">
                                <div class="nav-group">
                                    <div class="tit blue">指标考核</div>
                                    <div class="cont sky">
                                        <span @click="openInNewTab('/ssddt',1);">缩水大厅</span>
                                        <span @click="openInNewTab('/ssdgw',2);">缩水单冠王</span>
                                        <span @click="openInNewTab('/sdssxb',3);">十大学霸</span>
                                        <span @click="openInNewTab('/hxwysz',4);">海选万元实战单</span>
                                    </div>
                                </div>
                                <div class="nav-group">
                                    <div class="tit magenta">跳蚤市场</div>
                                    <div class="cont sky">
                                        <span @click="openInNewTab('/excel',4);">EXCEL技巧师大厅</span>
                                        <span @click="openInNewTab('/suoshuiruanjian',5)">缩水软件特区</span>
                                    </div>
                                </div>
                                <div class="nav-group">
                                    <div class="tit green">帮扶中心</div>
                                    <div class="cont sky">
                                        <span @click="openInNewTab('/sttzzbfzx',6);">投注站申请帮扶</span>
                                        <span @click="openInNewTab('/sttzzbfzx',6);">实战超市</span>
                                        <span @click="openInNewTab('/sttzzbfzx',6);">众筹招股大厅</span>
                                        <span @click="openInNewTab('/sttzzbfzx',6);">彩票代表海选</span>
                                    </div>
                                </div>
                                <div class="nav-group">
                                    <div class="tit orange">申请入住</div>
                                    <div class="cont sky">
                                        <span @click="openInNewTab('/personalCenter/hangjiaguanli/apply_sss',null)">缩水师申请</span>
                                        <span @click="openInNewTab('/personalCenter/tzz_bf/cp_tzz_sq_bf',null);">彩票投注站申请</span>
                                        <span @click="openInNewTab('','')">技巧师申请</span>
                                        <span @click="openInNewTab('','')">软件交易师申请</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <!-- <span>在线客服</span> -->
                        <!-- <a href="tencent://message/?uin=1173679416&Site=JooIT.com&Menu=yes">
							<img src="@/assets/login/qq.png" alt=""/>
						</a> -->
                        <!-- <a href="tencent://message/?uin=970611994&Site=JooIT.com&Menu=yes">
							<img src="@/assets/login/qq.png" alt=""/>
						</a> -->
                        <img @click="artificial" src="@/assets/login/qq.png" alt="" />
                    </div>
                </div>
            </div>
        </div>
        <hxlMenu />
    </div>
</template>

<script>
import hxlMenu from "./menu.vue";

export default {
    name: "app-header",
    components: {
        hxlMenu,
    },
    data() {
        return {
            userInfo: {},
        };
    },
    mounted() {
        // setTimeout(_=>{
        // 	this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
        // },1200)
    },
    methods: {
        // 新标签页打开站内路由（与首页保持一致）
        openInNewTab(path, menuActiveIndex = null) {
            if (menuActiveIndex === "") {
                return;
            }
            this.$vuex("vuex_menuActiveIndex", menuActiveIndex);
            const env = process.env.NODE_ENV;
            let obj = {
                development: "http://localhost:8080", // 本地开发地址
                production: process.env.VUE_APP_BASE_API, // 线上地址
            };
            const fullUrl = `${obj[env]}#${path}`;
            window.open(fullUrl, "_blank");
        },
        // 联系客服
        artificial() {
            // this.copyClipboard('1173679416')
            this.copyClipboard('168650441')
        },
        // 剪切板
        copyClipboard(data) {
            let url = data;
            let oInput = document.createElement("input");
            oInput.value = url;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象
            document.execCommand("Copy"); // 执行浏览器复制命令
            this.$notify({
                title: "成功",
                message: "qq号已复制到剪切板，请在腾讯QQ中搜索添加",
                type: "success",
                offset: 100,
            });
            oInput.remove();
        },
        outLogin() {
            localStorage.clear();
            this.$router.replace("/login");
        },
    },
};
</script>

<style lang="scss" scoped>
/* 彩票导航板块（移入 header 的 siteMap，全站公共显示；样式参考设计规范：彩色分组标题 + 横向链接网格） */
.siteMap {
    flex: 1;
    min-width: 0;
}

/* 彩票导航：默认仅显示「彩票导航」4字，悬浮触发下方分组面板 */
.lottery-nav {
    position: relative;
    display: inline-block;

    .nav-trigger {
        background: #d43c33;
        color: #fff;
        font-size: 15px;
        padding: 6px 14px;
        cursor: pointer;
        border-radius: 3px;
        white-space: nowrap;
        user-select: none;
    }

    .nav-panel {
        display: none;
        position: absolute;
        top: 100%;
        left: 50%;
        box-sizing: border-box;
        transform: translateX(-86%);
        width: 1200px;
        margin-top: 0;
        background: #fff;
        border: 1px solid rgba(0, 0, 0, 0.2);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        z-index: 999;
        padding: 14px 16px 16px;
        text-align: center;
        grid-template-columns: repeat(4, 1fr);

        .nav-group {
            display: inline-block;
            vertical-align: top;
            padding: 0 18px;
            border-left: 1px solid rgba(0, 0, 0, 0.1);

            &:first-child {
                border-left: none;
                padding-left: 0;
            }

            .tit {
                font-size: 18px;
                font-weight: bold;
                padding-bottom: 8px;

                &.blue { color: #3d7edb; }
                &.magenta { color: #d63384; }
                &.green { color: #2e9e5b; }
                &.orange { color: #e67817; }
            }

            .cont {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                column-gap: 20px;
                row-gap: 4px;

                span {
                    padding: 2px 0;
                    font-size: 14px;
                    cursor: pointer;
                    width: max-content;
                    position: relative;
                    color: #3072cd;

                    &:hover {
                        color: #d43c33;
                        text-decoration: underline;
                    }
                }
            }
        }
    }

    &:hover .nav-panel {
        display: grid;
    }
}

.dropDown {
    display: block;
    position: relative;

    &::before {
        content: "";
        display: block;
        position: absolute;
        top: 24px;
        right: 4px;
        width: 6px;
        height: 6px;
        border-bottom: 2px solid #999;
        border-right: 2px solid #999;
        transform: translateY(-50%) rotate(48deg);
    }
}


#header {
    .content {
        background-color: #f0f3f7;
    }

    .tit {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;

        >div {
            display: flex;
            align-items: center;

            >span {
                display: inline-block;
                padding: 15px 30px;
            }

            >div {
                &.userInfo {
                    display: flex;
                    align-items: center;
                    position: relative;

                    >span {
                        padding-left: 0;
                    }

                    >div {
                        span {
                            padding: 15px;
                            position: relative;
                            z-index: 10;
                            border: 1px solid transparent;
                            cursor: pointer;
                        }

                        &:hover>span {
                            background-color: #ffffff;
                            border: 1px solid rgba(0, 0, 0, 0.2);
                            border-bottom: 0;
                        }

                        &:hover ul {
                            display: block;
                        }
                    }

                    ul {
                        position: absolute;
                        top: 50px;
                        z-index: 9;
                        min-width: 150px;
                        display: none;
                        border: 1px solid rgba(0, 0, 0, 0.2);
                        text-align: center;
                        background-color: #ffffff;
                        list-style: none;
                        padding: 0;
                        margin: 0;
                        width: 200px;

                        li {
                            padding: 10px 20px;
                            cursor: pointer;

                            &:hover {
                                background-color: rgba(0, 0, 0, 0.1);
                            }

                            span {
                                padding: 0;
                            }
                        }
                    }

                    .msg {
                        border-bottom: 1px solid #4b8bb8;
                        color: #ff0000;
                        padding: 5px 10px;
                        margin-left: 20px;
                        display: flex;
                        align-items: center;

                        svg {
                            margin-right: 5px;
                        }
                    }
                }

                span {
                    display: inline-block;

                    &.btn {
                        margin-right: 10px;
                        border-radius: 5px;
                        cursor: pointer;

                        &.login {
                            background-color: #faaa25;
                            color: #ffffff;
                            font-weight: bold;
                        }

                        &.register {
                            border: 1px solid rgba(0, 0, 0, 0.2);
                        }
                    }
                }
            }
        }
    }
}
</style>
